// 用户管理路由
export default {
    path: 'user',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '用户管理'},
    children: [{
        path: 'fans',
        component: () => import('@/components/RouterView'),
        redirect: '/user/fans/list',
        meta: { title: '乐迷管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/fans/list.vue'),
            meta: {title: '乐迷列表'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/user/fans/edit.vue'),
            meta: {title: '乐迷基本信息'},
            props:true
        },{
            path: 'nickname',
            component: () => import('@/views/user/fans/nickname.vue'),
            meta: {title: '禁用昵称'}
        }]
    },{
        path: 'baseInfoAudit',
        component: () => import('@/components/RouterView'),
        redirect: '/user/baseInfoAudit/list',
        meta: { title: '基础信息审核'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/baseInfoAudit/list.vue'),
            meta: {title: '基础信息审核列表'}
        }]
    },{
        path: 'userPermit',
        component: () => import('@/components/RouterView'),
        redirect: '/user/userPermit/list',
        meta: { title: '工作人员管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/userPermit/list.vue'),
            meta: {title: '工作人员列表'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/user/userPermit/edit.vue'),
            meta: {title: '编辑工作人员'},
            props: true
        },{
            path: 'add',
            component: () => import('@/views/user/userPermit/edit.vue'),
            meta: {title: '新增工作人员'}
        }]
    },{
        path: 'changetel',
        component: () => import('@/components/RouterView'),
        redirect: '/user/changetel/list',
        meta: { title: '手机号对调'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/changetel/list.vue'),
            meta: {title: '手机号对调列表'}
        }]
    },{
        path: 'realName',
        component: () => import('@/components/RouterView'),
        redirect: '/user/realName/list',
        meta: { title: '实名管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/realNameManage/list.vue'),
            meta: {title: '证件信息管理'}
        },{
            path: 'faceManage',
            component: () => import('@/views/user/realNameManage/faceManage.vue'),
            meta: {title: '人脸验证管理'}
        },{
            path: 'exemption',
            component: () => import('@/views/user/realNameManage/exemption.vue'),
            meta: {title: '免检证件管理'}
        }]
    },{
        path: 'punish',
        component: () => import('@/components/RouterView'),
        redirect: '/user/punish/list',
        meta: { title: '处罚管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/punish/list.vue'),
            meta: {title: '处罚管理列表'}
        }]
    },{
        path: 'artist',
        component: () => import('@/components/RouterView'),
        redirect: '/user/artist/list',
        meta: { title: '艺人管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/artist/list'),
            meta: {title: '艺人列表'}
        },{
            path: 'edit/baseInfo/:id',
            component: () => import('@/views/user/artist/edit/baseInfo'),
            meta: {title: '艺人基本信息'},
            props:true
        },{
            path: 'edit/music/:id',
            component: () => import('@/views/user/artist/edit/music'),
            meta: {title: '艺人歌曲管理'},
            props:true
        },{
            path: 'edit/media/:id',
            component: () => import('@/views/user/artist/edit/media'),
            meta: {title: '艺人相册管理'},
            props:true
        },{
            path: 'edit/video/:id',
            component: () => import('@/views/user/artist/edit/video'),
            meta: {title: '艺人视频管理'},
            props:true
        },{
            path: 'edit/live/:id',
            component: () => import('@/views/user/artist/edit/live'),
            meta: {title: '艺人直播管理'},
            props:true
        },{
            path: 'edit/account/:id',
            component: () => import('@/views/user/artist/edit/account'),
            meta: {title: '艺人账号管理'},
            props:true
        },{
            path: 'edit/auth/:id',
            component: () => import('@/views/user/artist/edit/auth'),
            meta: {title: '艺人认证信息'},
            props:true
        },{
            path: 'edit/finance/:id',
            component: () => import('@/views/user/artist/edit/finance'),
            meta: {title: '艺人财务信息'},
            props:true
        },{
            path: 'edit/openservice/:id',
            component: () => import('@/views/user/artist/edit/openservice'),
            meta: {title: '艺人开通服务'},
            props:true
        }]
    },{
        path: 'site',
        component: () => import('@/components/RouterView'),
        redirect: '/user/site/list',
        meta: { title: '场地管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/site/list'),
            meta: {title: '场地列表'}
        },{
            path: 'edit/baseInfo/:id',
            component: () => import('@/views/user/site/edit/baseInfo'),
            meta: {title: '场地基本信息'},
            props:true
        },{
            path: 'edit/media/:id',
            component: () => import('@/views/user/site/edit/media'),
            meta: {title: '场地相册管理'},
            props:true
        },{
            path: 'edit/video/:id',
            component: () => import('@/views/user/site/edit/video'),
            meta: {title: '场地视频管理'},
            props:true
        },{
            path: 'edit/live/:id',
            component: () => import('@/views/user/site/edit/live'),
            meta: {title: '场地直播管理'},
            props:true
        },{
            path: 'edit/account/:id',
            component: () => import('@/views/user/site/edit/account'),
            meta: {title: '场地账号管理'},
            props:true
        },{
            path: 'edit/auth/:id',
            component: () => import('@/views/user/site/edit/auth'),
            meta: {title: '场地认证信息'},
            props:true
        },{
            path: 'edit/finance/:id',
            component: () => import('@/views/user/site/edit/finance'),
            meta: {title: '场地财务信息'},
            props:true
        },{
            path: 'edit/openservice/:id',
            component: () => import('@/views/user/site/edit/openservice'),
            meta: {title: '场地开通服务'},
            props:true
        },{
            path: 'edit/seatMap/:id',
            component: () => import('@/views/user/site/edit/seatMap'),
            meta: {title: '场地座位图'},
            props:true
        }]
    },{
        path: 'brand',
        component: () => import('@/components/RouterView'),
        redirect: '/user/brand/list',
        meta: { title: '厂牌管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/brand/list'),
            meta: {title: '厂牌列表'}
        },{
            path: 'edit/baseInfo/:id',
            component: () => import('@/views/user/brand/edit/baseInfo'),
            meta: {title: '厂牌基本信息'},
            props:true
        },{
            path: 'edit/media/:id',
            component: () => import('@/views/user/brand/edit/media'),
            meta: {title: '厂牌相册管理'},
            props:true
        },{
            path: 'edit/video/:id',
            component: () => import('@/views/user/brand/edit/video'),
            meta: {title: '厂牌视频管理'},
            props:true
        },{
            path: 'edit/live/:id',
            component: () => import('@/views/user/brand/edit/live'),
            meta: {title: '厂牌直播管理'},
            props:true
        },{
            path: 'edit/account/:id',
            component: () => import('@/views/user/brand/edit/account'),
            meta: {title: '厂牌账号管理'},
            props:true
        },{
            path: 'edit/auth/:id',
            component: () => import('@/views/user/brand/edit/auth'),
            meta: {title: '厂牌认证信息'},
            props:true
        },{
            path: 'edit/finance/:id',
            component: () => import('@/views/user/brand/edit/finance'),
            meta: {title: '厂牌财务信息'},
            props:true
        },{
            path: 'edit/openservice/:id',
            component: () => import('@/views/user/brand/edit/openservice'),
            meta: {title: '厂牌开通服务'},
            props:true
        }]
    },{
        path: 'userAuth',
        component: () => import('@/components/RouterView'),
        redirect: '/user/userAuth/list',
        meta: { title: '认证审核'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/userAuth/list'),
            meta: {title: '认证审核列表'}
        },{
            path: ':id',
            component: () => import('@/views/user/userAuth/detail'),
            meta: {title: '认证审核详情'},
            props:true
        }]
    },{
        path: 'userClaim',
        component: () => import('@/components/RouterView'),
        redirect: '/user/userClaim/list',
        meta: { title: '认领审核'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/userClaim/list'),
            meta: {title: '认领审核列表'}
        },{
            path: ':id',
            component: () => import('@/views/user/userClaim/detail'),
            meta: {title: '认领审核详情'},
            props:true
        }]
    },{
        path: 'realNameAudit',
        component: () => import('@/components/RouterView'),
        redirect: '/user/realNameAudit/list',
        meta: { title: '实名信息修改审核'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/realNameAudit/list'),
            meta: {title: '实名信息修改审核列表'}
        }]
    },{
        path: 'approval',
        component: () => import('@/components/RouterView'),
        redirect: '/user/approval/list',
        meta: { title: '报批管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/user/approval/list'),
            meta: {title: '报批管理列表'}
        }]
    }]
}